import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { ConfigLoader } from './services/config-loader';
import { BaseService } from './services/base.service';
import { ConfigService } from './services/config.service';
import { LanguagesService } from './services/language.service';
import { ValidationService } from './services/validation.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { NgxTypeaheadModule } from 'ngx-typeahead';
import { MoiaCaptchaComponent } from './components/moia-captcha/moia-captcha.component';
import { ControlMessages } from './components/control-messages/controlMessages.component';
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { LastWorksComponent } from './components/registration/last-works.component';
import { DeclarationSignatureComponent } from './components/registration/declaration-signature.component';
import { PersonalInfoComponent } from './components/registration/personal-info.component';
import { HeadFamilyComponent } from './components/registration/head-family.component';
import { PartnerDataComponent } from './components/registration/partner-data.component';
import { ChildrenDataComponent } from './components/registration/children-data.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from 'node_modules/@angular/platform-browser/animations';
import { MandatoryDirective } from './directives/mandatory.directive';
import { DigitalOnlyDirective } from './directives/digitalOnly.directive';
import { ReplacePipe } from './pipes/replace.pipe';
import { FindComponent } from './components/find/find.component';
import { TabsComponent } from './components/tabs-control/tabs-control.component';
import { AssistanceComponent } from './components/assistance/assistance.component';
import { VirtualKeyboardComponent } from './components/virtual-keyboard/virtual-keyboard.component';
import { PopupBoxComponent } from './components/popupBox.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { IsraelyStatusComponent } from './components/registration/israely-status.component';
import { ExperienceComponent } from './components/assistance/experience/experience.component';
import { ProfessionComponent } from './components/assistance/profession/profession.component';
import { EducitionComponent } from './components/assistance/educition/educition.component';
import { TimerService } from './services/timer.service';
import { TimeoutDialogComponent } from './components/timeout-dialog/timeout-dialog.component';
import { YesNoComponent } from './components/registration/YesNo.component';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { NgxCaptchaModule } from 'ngx-captcha';
import { RecaptchaService } from './services/recaptcha.service';


export declare var grecaptcha: any;
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MandatoryDirective,
    DigitalOnlyDirective,
    ReplacePipe,
    MoiaCaptchaComponent,
    ControlMessages,
    LoginComponent,
    RegistrationComponent,
    LastWorksComponent,
    DeclarationSignatureComponent,
    PersonalInfoComponent,
    HeadFamilyComponent,
    PartnerDataComponent,
    ChildrenDataComponent,
    TabsComponent,
    FindComponent,
    AssistanceComponent,
    FindComponent,
    VirtualKeyboardComponent,
    ExperienceComponent,
    ProfessionComponent,
    EducitionComponent,
    IsraelyStatusComponent,
    VirtualKeyboardComponent,
    PopupBoxComponent,
    WelcomeComponent,
    TimeoutDialogComponent,
    YesNoComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    HttpClientModule,
    NgxTypeaheadModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxCaptchaModule
  ],
  exports: [
    BsDatepickerModule
  ],
  providers: [
    BaseService,
    LanguagesService,
    ValidationService,
    TimerService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [ConfigService],
      multi: true
    },
    ReCaptchaV3Service,
    RecaptchaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
